import { useEffect, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { track } from '@fff-web/fff-analytics';
import { getProductReviews } from '../services/api/questionnaire';
import PageContainer from '../shared-components/PageContainer/PageContainer';
import { segmentEnum } from '../utils/segment';
import ProductList from './ProductList/ProductList';
import RateAndReviewEmpty from './RateAndReviewEmpty/RateAndReviewEmpty';
import RateAndReviewHeader from './RateAndReviewHeader/RateAndReviewHeader';
import * as styles from './styles.module.scss';

const RateAndReview = () => {
  const [products, setProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const { rateAndReviewMaxPurchaseDate: rateAndReviewMaxPurchaseDateFF } = useFlags();

  useEffect(() => {
    const fetchProductReviews = async () => {
      try {
        const { data } = await getProductReviews(rateAndReviewMaxPurchaseDateFF);
        setProducts(data.items);
      } catch (error) {
        setProducts([]);

        console.error(error);
      } finally {
        setLoadingProducts(false);
      }
    };
    fetchProductReviews();
  }, [rateAndReviewMaxPurchaseDateFF]);

  useEffect(() => {
    if (products.length) {
      track({
        trackName: segmentEnum.rateAndReview,
        properties: {
          products_available: products.length,
        },
      });
    }
  }, [products.length]);

  const renderContent = () => {
    if (loadingProducts) return null;
    if (products.length) return <ProductList products={products} />;
    return <RateAndReviewEmpty />;
  };

  return (
    <PageContainer>
      <div className={styles.container}>
        <RateAndReviewHeader />
        {renderContent()}
      </div>
    </PageContainer>
  );
};

export default RateAndReview;
